import { render, staticRenderFns } from "./agv-ad-banner.vue?vue&type=template&id=65d803d8&scoped=true&lang=pug&"
import script from "./agv-ad-banner.vue?vue&type=script&lang=js&"
export * from "./agv-ad-banner.vue?vue&type=script&lang=js&"
import style0 from "./agv-ad-banner.vue?vue&type=style&index=0&id=65d803d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d803d8",
  null
  
)

export default component.exports